import { HttpParams } from "@angular/common/http";
import { Params } from "@angular/router";

export interface ListFilterPayload {
    center?: number;
    programIds?: number[];
    searchText?: string;
    searchTerm?: string;
    limit?: number;
    page?: number;
    orderBy?: string;
    order?: string;
    [k:string]: any;
}

export class RouteParams {
    pageParams: Params;
    filteredParams: {[k:string]: any};
    defaultSortBy: string;
    filterKeys: string[];
    defaultSortIn: string;
    defaultLimit: number;
    defaultPage: number;

    constructor(
        params: Params, 
        defaultSortBy: string, 
        filterKeys: string[] = [], 
        defaultSortIn: string = 'desc', 
        defaultLimit: number = 20, 
        defaultPage: number = 1
    ) {
        this.pageParams = params;
        this.filteredParams = params;
        this.defaultSortBy = defaultSortBy;
        this.filterKeys = filterKeys;
        this.defaultSortIn = defaultSortIn;
        this.defaultLimit = defaultLimit;
        this.defaultPage = defaultPage;
    }
    
    private assignDefaults() {
        if (!this.filteredParams['limit'])  this.filteredParams['limit'] = this.defaultLimit; 
        if (!this.filteredParams['page']) this.filteredParams['page'] = this.defaultPage;
        if (!this.filteredParams['orderBy']) this.filteredParams['orderBy'] = this.defaultSortBy;
        if (!this.filteredParams['order']) this.filteredParams['order'] = this.defaultSortIn;
    }

    parseRequestParams(newParams?: {[k:string]: any}): HttpParams {
        if (newParams) this.filteredParams = newParams;
        this.assignDefaults();
        let requestParams = new HttpParams();

        if (this.filteredParams) {
            for (const key in this.filteredParams) {
                if (this.filteredParams.hasOwnProperty(key)) {
                    if (typeof(requestParams.get(key)) == 'object' && requestParams?.get(key)?.length) {
                        requestParams = requestParams
                            .set(
                                key, 
                                `${requestParams.get(key)},${this.filteredParams[key]}`
                            );
                    } else {
                        requestParams = requestParams
                            .set(key, this.filteredParams[key]);
                    }
                    
                }
            }
        }
        return requestParams;
    }
  
    parseFilterPayload(newParams?: {[k:string]: any}): ListFilterPayload {
      if (newParams) this.filteredParams = {...newParams};
      let parsedFilters: ListFilterPayload = {};

      const hasFilterValue = (fltrKey: string) => {
        return this.filteredParams.hasOwnProperty(fltrKey) && this.filteredParams[fltrKey];
      }

      const parseFromString = (value: any) => {
        return (typeof(this.filteredParams[value]) == 'string') 
            ? parseInt(this.filteredParams[value]) 
            : this.filteredParams[value];
      }

      if (hasFilterValue('center')) {
        parsedFilters['center'] = parseFromString('center');
      }

      if (hasFilterValue('searchText')) 
        parsedFilters['searchText'] = this.filteredParams['searchText'].replace('%2b', '+');
      if (hasFilterValue('searchTerm')) 
          parsedFilters['searchTerm'] = this.filteredParams['searchTerm'];

      if (hasFilterValue('limit')) {
          parsedFilters['limit'] = parseFromString('limit');
      } else parsedFilters['limit'] = this.defaultLimit;

      if (hasFilterValue('page')) {
          parsedFilters['page'] = parseFromString('page');
      } else parsedFilters['page'] = this.defaultPage;

      parsedFilters['orderBy'] = (hasFilterValue('orderBy')) ? this.filteredParams['orderBy'] : this.defaultSortBy;
      parsedFilters['order'] = (hasFilterValue('order')) ? this.filteredParams['order'] : this.defaultSortIn;

      if (this.filterKeys?.length) {
        this.filterKeys.forEach((fKey, index) => {
            if (hasFilterValue(fKey)) {
                parsedFilters[fKey] = this.filteredParams[fKey];
            }
        });
      }
      return parsedFilters;
    }
}